var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.866 20.588a8 8 0 108-13.856 8 8 0 00-8 13.857zm-1 1.732c4.783 2.762 10.899 1.123 13.66-3.66C25.288 13.877 23.65 7.761 18.866 5 14.083 2.239 7.967 3.877 5.206 8.66c-2.762 4.783-1.123 10.9 3.66 13.66z",
    fill: "#7A8595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.82a1 1 0 111.732 1l-7.5 12.99a1 1 0 01-1.732-1L8 21.82z",
    fill: "#7A8595"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljg2NiAyMC41ODhhOCA4IDAgMTA4LTEzLjg1NiA4IDggMCAwMC04IDEzLjg1N3ptLTEgMS43MzJjNC43ODMgMi43NjIgMTAuODk5IDEuMTIzIDEzLjY2LTMuNjZDMjUuMjg4IDEzLjg3NyAyMy42NSA3Ljc2MSAxOC44NjYgNSAxNC4wODMgMi4yMzkgNy45NjcgMy44NzcgNS4yMDYgOC42NmMtMi43NjIgNC43ODMtMS4xMjMgMTAuOSAzLjY2IDEzLjY2eiIgZmlsbD0iIzdBODU5NSIvPgogIDxwYXRoIGQ9Ik04IDIxLjgyYTEgMSAwIDExMS43MzIgMWwtNy41IDEyLjk5YTEgMSAwIDAxLTEuNzMyLTFMOCAyMS44MnoiIGZpbGw9IiM3QTg1OTUiLz4KPC9zdmc+Cg==";
export { SvgLoop as ReactComponent };